export default "assets/images/home-programmes-bg-2360b0d9.jpeg";